const siteModal = {
  displayField: 'adminTitle',
  name: 'Site Modal',
  description: 'Modal when clicking the world icon in the main navigation',
  fields: [
    {
      id: 'adminTitle',
      name: 'Admin Title',
      type: 'Symbol',
      localized: false,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'headline',
      name: 'Intro Headline',
      type: 'Symbol',
      localized: true,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'richText',
      name: 'Intro Copy',
      type: 'RichText',
      localized: true,
      required: false,
      validations: [
        {
          enabledMarks: [ 'bold', 'italic', 'underline', 'superscript', 'subscript' ],
          message: 'Only bold, italic, underline, superscript, and subscript marks are allowed'
        },
        {
          enabledNodeTypes: [ 'heading-3', 'ordered-list', 'unordered-list' ],
          message: 'Only heading 3, ordered list, and unordered list nodes are allowed'
        },
        { nodes: {} }
      ],
      disabled: false,
      omitted: false
    },
    {
      id: 'img',
      name: 'Intro Image',
      type: 'Link',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'welcomeMessage',
      name: 'Welcome Message',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'accountLoginHeadline',
      name: 'Account Login Headline',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'createAccountHeadline',
      name: 'Create Account Headline',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'createAccountCopy',
      name: 'Create Account Copy',
      type: 'RichText',
      localized: true,
      required: false,
      validations: [
        {
          enabledMarks: [
            'italic',
            'underline',
            'code',
            'superscript',
            'subscript',
            'bold'
          ],
          message: 'Only italic, underline, code, superscript, subscript, and bold marks are allowed'
        },
        {
          enabledNodeTypes: [ 'heading-3', 'ordered-list', 'unordered-list' ],
          message: 'Only heading 3, ordered list, and unordered list nodes are allowed'
        },
        { nodes: {} }
      ],
      disabled: false,
      omitted: false
    },
    {
      id: 'usernameExistsException',
      name: 'Error Message: Username Exists Exception',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'invalidPasswordException',
      name: 'Error Message: Invalid Password Exception',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'invalidParameterException',
      name: 'Error Message: Invalid Parameter Exception',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'tooManyRequestsException',
      name: 'Error Message: Too Many Requests Exception',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'resourceNotFoundException',
      name: 'Error Message: Resource Not Found Exception',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'notAuthorizedException',
      name: 'Error Message: Not Authorized Exception',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'codeMismatchException',
      name: 'Error Message: Code Mismatch Exception',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'userNotConfirmedException',
      name: 'Error Message: User Not Confirmed Exception',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'userNotFoundException',
      name: 'Error Message: User Not Found Exception',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'networkError',
      name: 'Error Message: NetworkError',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'defaultRegistrationExcemption',
      name: 'Default Registration Excemption',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'defaultError',
      name: 'Error Message: Default Error',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'verificationHeadline',
      name: 'Verification Headline',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'verificationCopy',
      name: 'Verification Copy',
      type: 'RichText',
      localized: true,
      required: false,
      validations: [
        {
          enabledMarks: [
            'code',
            'superscript',
            'subscript',
            'bold',
            'italic',
            'underline'
          ],
          message: 'Only code, superscript, subscript, bold, italic, and underline marks are allowed'
        },
        {
          enabledNodeTypes: [
            'heading-3',
            'unordered-list',
            'ordered-list',
            'hyperlink'
          ],
          message: 'Only heading 3, unordered list, ordered list, and link to Url nodes are allowed'
        },
        { nodes: {} }
      ],
      disabled: false,
      omitted: false
    },
    {
      id: 'invalidEmailMessage',
      name: 'Invalid Email Message',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'verificationCodeErrorMessage',
      name: 'Verification Code Error Message',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'emptyPasswordMessage',
      name: 'Empty Password Message',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'confirmPasswordMismatch',
      name: 'ConfirmPasswordMismatch',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'verificationCodeSentMessage',
      name: 'VerificationCodeSentMessage',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'resetPasswordMessage',
      name: 'Reset Password Message',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'emailOrPasswordInvalidMessage',
      name: 'Email or Password Invalid Message',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'rememberMeCheckbox',
      name: 'Remember Me Checkbox',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'rememberMeDisclaimer',
      name: 'Remember Me Disclaimer',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'siteModal',
    version: 26,
    updatedAt: '2023-11-28T19:34:02.878Z'
  }
};
export default siteModal;